import { BaseService } from "./base.service";
import {
	IEvaluationSupportingDocument,
	ISupportingDocument,
} from "models/EvaluationSupportingDocumentModel";

class EvaluationSupportingDocumentServiceInternal extends BaseService {
	getEvaluationSupportingDocumentItemList = async (
		evaluationItemId: number
	): Promise<IEvaluationSupportingDocument[]> =>
		this.callApi<IEvaluationSupportingDocument[]>(
			`EvaluationSupportingDocumentItem/GetAll/${evaluationItemId}`,
			"GET"
		);

	getAllEvaluationSupportingDocumentList = async (
		sortBy?: string,
		sortType: "ASC" | "DESC" = "ASC"
	): Promise<ISupportingDocument[]> =>
		this.callApi<ISupportingDocument[]>(
			`EvaluationSupportingDocument/GetAll`,
			"GET",
			sortBy ? new URLSearchParams({ sortBy, sortType }) : undefined
		);

	saveEvaluationSupportingDocumentItem = async (model: {
		evaluationItemId: number;
		evaluationSupportingDocument: string;
	}): Promise<number> =>
		this.callApi<number>(
			`EvaluationSupportingDocumentItem/Save`,
			"POST",
			undefined,
			model
		);

	saveUpdateAllEvaluationSupportingDocuments = async (
		model: { evaluationSupportingDocumentId: number; name: string }[]
	): Promise<boolean> =>
		this.callApi<boolean>(
			`EvaluationSupportingDocument/SaveUpdateAll`,
			"POST",
			undefined,
			model
		);

	deleteEvaluationSupportingDocumentItem = async (
		evaluationSupportingDocumentId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`EvaluationSupportingDocumentItem/Delete/${evaluationSupportingDocumentId}`,
			"DELETE"
		);

	deleteEvaluationSupportingDocument = async (
		evaluationSupportingDocumentId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`EvaluationSupportingDocument/Delete/${evaluationSupportingDocumentId}`,
			"DELETE"
		);
}

export const EvaluationSupportingDocumentService =
	new EvaluationSupportingDocumentServiceInternal();
